import { render, staticRenderFns } from "./VolunteerStatusBadge.vue?vue&type=template&id=c93950c2&"
import script from "./VolunteerStatusBadge.vue?vue&type=script&lang=js&"
export * from "./VolunteerStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports